/*
 Общий планировщик выравнивания высот параметров для всех строк сразу.

 Раньше каждая строка считала свои высоты сама в отдельном кадре: сбрасывала
 заданные высоты, заставляла браузер пересчитать раскладку и читала настоящие
 размеры. Когда строк много, браузер пересчитывал раскладку по разу на каждую
 строку, и первая отрисовка таблицы заметно подтормаживала.

 Теперь строки складывают свою работу сюда и мы делаем всё разом за один кадр:
 сначала у всех сбрасываем высоты, потом один раз читаем размеры, потом у всех
 проставляем итоговые. Получается один пересчёт раскладки на кадр, а не по разу
 на строку.
*/

export interface ParamHeightJob {
  /** сбросить ранее проставленные высоты, чтобы взять настоящую высоту содержимого */
  clear: () => void;
  /** прочитать настоящие высоты и запомнить их у себя */
  measure: () => void;
  /** проставить итоговые высоты на строку */
  apply: () => void;
}

const pending = new Set<ParamHeightJob>();
let rafId = 0;

function flush() {
  rafId = 0;
  if (!pending.size) return;
  const jobs = Array.from(pending);
  pending.clear();
  // сначала у всех сбрасываем заданные высоты (только запись в стили)
  for (const j of jobs) j.clear();
  // потом читаем размеры. Первое чтение пересчитает раскладку один раз с учётом
  // всех сбросов, дальше идут только чтения, поэтому лишних пересчётов нет.
  for (const j of jobs) j.measure();
  // и в конце проставляем итоговые высоты
  for (const j of jobs) j.apply();
}

export function requestParamHeightAlign(job: ParamHeightJob): void {
  pending.add(job);
  if (rafId) return;
  rafId = requestAnimationFrame(flush);
}

export function cancelParamHeightAlign(job: ParamHeightJob): void {
  pending.delete(job);
}
